import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-toast__body" }
const _hoisted_2 = { class: "app-toast__title" }
const _hoisted_3 = {
  key: 0,
  class: "app-toast__message"
}

import { computed } from 'vue'
import type { Toast } from '@/composables/useToast'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppToast',
  props: {
    toast: {}
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {

const ICON_MAP: Record<string, string> = {
  success: 'bi-check-circle-fill',
  error: 'bi-x-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
}

const props = __props

const emit = __emit

function handleAction() {
  props.toast.onAction?.()
  emit('dismiss', props.toast.id)
}

const iconClass = computed(() => ICON_MAP[props.toast.type])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['app-toast', `app-toast--${__props.toast.type}`]),
    role: "alert"
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(['bi', iconClass.value, 'app-toast__icon'])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.toast.title), 1),
      (__props.toast.message)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.toast.message), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.toast.actionLabel)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "app-toast__action",
          onClick: handleAction
        }, _toDisplayString(__props.toast.actionLabel), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "btn-close app-toast__close",
      "aria-label": "Close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss', __props.toast.id)))
    })
  ], 2))
}
}

})